var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseEditable',_vm._g(_vm._b({ref:"description",staticClass:"menu-item--description flex mb-1 xs12 row",attrs:{"tag":_vm.tagWithClasses}},'BaseEditable',Object.assign({}, _vm.$attrs, _vm.$props),false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }